module.exports = __webpack_public_path__ + "static/media/world.3c8ccc03.svg";